import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-5c848959"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "search-box" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.22611 0C9.65783 0 12.4503 2.712 12.4503 6.04691C12.4503 7.09006 12.1706 8.12013 11.64 9.026C11.5534 9.17356 11.4602 9.31644 11.3641 9.45466C11.3179 9.52003 11.2641 9.57886 11.217 9.64237L15.1101 13.4274C15.5927 13.8943 15.5917 14.6527 15.1101 15.1215C14.8698 15.3549 14.5536 15.4717 14.2383 15.4717C13.922 15.4717 13.6067 15.3549 13.3664 15.1215L9.38291 11.2496C9.26852 11.315 9.15509 11.3794 9.01763 11.4485C8.13711 11.879 7.19795 12.0957 6.22611 12.0957C2.7944 12.0957 0 9.38181 0 6.04691C0 2.71294 2.79344 0 6.22611 0ZM6.22506 9.6985C6.80855 9.6985 7.37569 9.56682 7.89766 9.31187C7.99379 9.26238 8.08799 9.21475 8.18508 9.15685C8.64072 8.88509 9.02426 8.52928 9.32802 8.09875C9.38762 8.01564 9.44434 7.92879 9.49528 7.84194C9.81827 7.28908 9.98265 6.68579 9.98265 6.04701C9.98265 4.03449 8.29659 2.39738 6.22506 2.39738C4.15257 2.39738 2.46651 4.03449 2.46651 6.04701C2.46651 8.05953 4.15161 9.6985 6.22506 9.6985Z",
        fill: "#1C1C1C"
    })
], -1));
const _hoisted_3 = ["placeholder", "disabled"];
import { computed, ref, watch } from "vue";
// Define the props for the TextInput component
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchTextBox',
    props: {
        primary: Boolean,
        secondary: Boolean,
        disabled: Boolean,
        placeholder: {
            type: String,
            default: "Enter text...",
        },
        value: {
            type: String,
            default: "",
        },
    },
    emits: ["update:value"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // Internal value to support v-model
        const inputValue = ref(props.value);
        // const emit = defineEmits({(event: "update:value", value: string): void;}];
        const emit = __emit;
        // Update the parent component when inputValue changes (for v-model)
        watch(inputValue, (newValue) => {
            emit("update:value", newValue);
        });
        // Compute the class based on the props
        const inputClass = computed(() => ({
            primary: props.primary,
            secondary: props.secondary,
            disabled: props.disabled,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(inputClass.value),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputValue).value = $event)),
                    placeholder: __props.placeholder,
                    disabled: __props.disabled
                }, null, 10, _hoisted_3), [
                    [_vModelText, inputValue.value]
                ])
            ]));
        };
    }
});
